import { appUrls, getAppRedirectPath } from "@/constants";
import { env } from "@/env";

export function getPostAuthRedirectUrl({
  isNewUser,
  redirectTo,
  pathname,
}: {
  isNewUser: boolean;
  redirectTo?: string;
  pathname: string;
}) {
  const rawPath = redirectTo || getAppRedirectPath(pathname);
  const redirectPath = rawPath.replace(/^\/app/, "");

  if (isNewUser) {
    const postSignupUrl = new URL(appUrls.googleOneTapRedirect);
    postSignupUrl.searchParams.set("redirect", `/app${redirectPath}`);
    return postSignupUrl.toString();
  }

  return `${env.NEXT_PUBLIC_WEB_APP_URL}${redirectPath}`;
}
